
import HeaderBarMenu from './index.vue'
// 为组件提供 install 方法
HeaderBarMenu.install = function (Vue) {
    Vue.component(HeaderBarMenu.name, HeaderBarMenu)
}
// 导出组件
export default HeaderBarMenu
